module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("开票信息管理")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "span": 7
    }
  }, [_c('h3', {
    staticClass: "panel-header"
  }, [_vm._v("开票列表")]), _vm._v(" "), _c('ul', {
    staticClass: "company-list"
  }, _vm._l((_vm.companyList), function(item, index) {
    return _c('li', {
      class: {
        'active': _vm.currentIndex === index
      },
      on: {
        "click": function($event) {
          _vm.chooseCompany(index)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }))]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "span": 16
    }
  }, [_c('h3', {
    staticClass: "panel-header"
  }, [_vm._v("开票信息")]), _vm._v(" "), _c('ul', {
    staticClass: "note-info"
  }, [_c('li', [_c('em', [_vm._v("名称")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.note.title))]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.copyText($event)
      }
    }
  }, [_vm._v("复制")])]), _vm._v(" "), _c('li', [_c('em', [_vm._v("税号")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.note.tax_no))]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.copyText($event)
      }
    }
  }, [_vm._v("复制")])]), _vm._v(" "), _c('li', [_c('em', [_vm._v("单位地址")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.note.address))]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.copyText($event)
      }
    }
  }, [_vm._v("复制")])]), _vm._v(" "), _c('li', [_c('em', [_vm._v("电话号码")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.note.telephone))]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.copyText($event)
      }
    }
  }, [_vm._v("复制")])]), _vm._v(" "), _c('li', [_c('em', [_vm._v("开户银行")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.note.bank_name))]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.copyText($event)
      }
    }
  }, [_vm._v("复制")])]), _vm._v(" "), _c('li', [_c('em', [_vm._v("银行账户")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.note.bank_num))]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.copyText($event)
      }
    }
  }, [_vm._v("复制")])])])])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59935411"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoicemanage/invoicemanage.vue
// module id = 821
// module chunks = 1